<script setup lang="ts">
    withDefaults(defineProps<{
        title: string;
        description: string;
        url: string;
        type: string;
        keywords?: string;
        ogTitle?: string;
        image?: string;
        imageAlt?: string;
        twitterImage?: string;
        twitterCard?: "summary" | "summary_large_image";
        robots?: string;
        modifiedTime?: string;
        ogLocale?: string;
    }>(), {
        image: "https://paradigma.me/assets/img/share-img/facebook.jpg",
        twitterImage: "https://paradigma.me/assets/img/share-img/twitter.jpg",
        twitterCard: "summary",
    });

    const urlReq = useRequestURL()
</script>

<template>
    <Head>
        <!-- TIILE -->
        <Title v-if="title">{{ title }}</Title>

        <!-- META TAGS -->
        <Meta name="description" :content="description" v-if="description" />
        <Meta name="keywords" :content="keywords" v-if="keywords" />
        <Meta name="robots" :content="robots" v-if="robots" />

        <!-- OG TAGS -->
        <Meta property="og:type" :content="type" v-if="type" />
        <Meta property="og:url" :content="url" v-if="url" />
        <Meta property="og:title" :content="ogTitle || title" v-if="ogTitle || title" />
        <Meta property="og:description" :content="description" v-if="description" />
        <Meta property="og:image" :content="image" />
        <Meta property="og:image:type" content="image/jpeg"/>
        <Meta property="og:image:width" content="1200" />
        <Meta property="og:image:height" content="630" />
        <Meta property="og:image:alt" :content="imageAlt" v-if="imageAlt" />
        <Meta property="og:site_name" content="Paradigma" />
        <Meta property="og:locale" :content="ogLocale" v-if="ogLocale" />
        <Meta property="article:modified_time" :content="modifiedTime" v-if="modifiedTime" />

        <!-- OG TAGS TW -->
        <Meta name="twitter:card" :content="twitterCard"/>
        <Meta name="twitter:site" content="@Paradigma_Inn"/>
        <Meta property="twitter:title" :content="ogTitle || title" v-if="ogTitle || title" />
        <Meta property="twitter:description" :content="description" v-if="description" />
        <Meta property="twitter:image" :content="twitterImage" />

        <!-- CANONICAL TAG -->
        <Link rel="canonical" :href="url" v-if="url" />
    </Head>
</template>
